import { useInstantSearch } from 'react-instantsearch'

import { useUserResources } from 'shared/hooks/useUserResources'

import { GridContent } from 'entry-key/pages/entry/components/GridContent'

import { Content as ProductContent } from '../../Content'
import { TabSkeleton } from './TabSkeleton'

const ProductTabContent = () => {
  const { status, results } = useInstantSearch()
  const { userResources } = useUserResources()
  const showRetailMedia = window.env.newTail.enabled

  const isLoading = status === 'loading' || status === 'stalled'
  const hasResults = results?.nbHits && results.nbHits > 0

  const isInitialLoading = isLoading && !hasResults

  if (isInitialLoading || !userResources?.region) {
    return <TabSkeleton />
  }

  return (
    <GridContent showRetailMedia={showRetailMedia}>
      <ProductContent region={userResources.region} />
    </GridContent>
  )
}

export default ProductTabContent
